import React from "react";
import { propTypes } from "react-bootstrap/esm/Image";
import Icon from "../components/icon";
function button({ children,customClassName,labelClass, labelName, onClick,iconLeft, iconSize, iconRight, clickFunction, iconRightSize, searchValue, showFilter,clearSearhValue, isDisable }) {
  function clearSearch() {
    clearSearhValue("")
    }

  var disable = isDisable ? 'disabled' : ''; 
    return (
        <div className={`custom-button-wrapper ${disable}` }>
            <div className={`${customClassName} custom-button`} onClick={onClick}>
                <Icon
                    customClassName="icon-left"
                    name={iconLeft}
                    size={iconSize}
                    disabled={isDisable} 
                    containerClass={`${iconLeft===undefined ? "hidden" : ""}`}
                />
                <span className={labelClass}>{labelName !== undefined ? labelName : ""}</span>
                {iconRight!==undefined ?
                    <Icon
                        customClassName="icon-right"
                        name={iconRight}
                        size={iconRightSize}
                        containerClass={`${iconRight===undefined ? "hidden" : ""}`}
                        onClick={clickFunction}
                    />

                    : ""}

                {  searchValue && showFilter &&
                    <div className="filter-data-container">
                        <span className="filter-data-label">{searchValue}</span>
                        <span className="close-button" onClick={clearSearch}></span>
                    </div>}

                {children}

            </div>
        </div>
  );
}

export default button;
